import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { QueryProvider } from './providers/QueryProvider';
import { KeycloakProvider } from './providers/KeycloakProvider';
import DateProvider from './providers/DateProvider';
import { ThemeProvider } from './theme/ThemeContext';
import AppRoutes from './routes/AppRoutes';
import './App.css';
// Import API configuration to set up authentication interceptors
import './api/openApiConfig';


// Component to provide close button for snackbars
const SnackbarCloseButton = React.forwardRef<HTMLButtonElement, { id: string | number }>((props, ref) => {
    const { closeSnackbar } = useSnackbar();

    return (
        <IconButton
            ref={ref}
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(props.id)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
});

// Simplified routing component - let AppRoutes handle all routing logic
const AppWithAuth: React.FC = () => {
    return <AppRoutes />;
};

function App() {
    return (
        <ThemeProvider>
            <CssBaseline />
            <KeycloakProvider>
                <QueryProvider>
                    <DateProvider>
                        <SnackbarProvider 
                            maxSnack={3} 
                            autoHideDuration={3000}
                            action={(snackbarId) => (
                                <SnackbarCloseButton id={snackbarId} />
                            )}
                        >
                            <BrowserRouter>
                                <AppWithAuth />
                            </BrowserRouter>
                        </SnackbarProvider>
                    </DateProvider>
                </QueryProvider>
            </KeycloakProvider>
        </ThemeProvider>
    );
}

export default App;
